import { NavLink } from "react-router-dom";
import { NAV_LINKS } from "./links";

export const DesktopNav = () => {
    return (
        <div className="hidden md:flex items-center gap-9">
            {NAV_LINKS.map((l) => (
                <NavLink
                    key={l.to}
                    to={l.to}
                    end={l.to === "/"}
                    onClick={
                        l.to === "/"
                            ? () =>
                                  window.scrollTo({
                                      top: 0,
                                      behavior: "smooth",
                                  })
                            : undefined
                    }
                    data-testid={`nav-link-${l.label.toLowerCase()}`}
                    className={({ isActive }) =>
                        `font-body text-sm relative after:absolute after:left-0 after:-bottom-1.5 after:h-[2px] after:bg-neon after:transition-all after:duration-300 ${
                            isActive
                                ? "text-black after:w-full"
                                : "text-black/70 hover:text-black after:w-0 hover:after:w-full"
                        }`
                    }
                >
                    {l.label}
                </NavLink>
            ))}
        </div>
    );
};
